import React, { useMemo } from "react";

import styled from "@emotion/styled";

import { iShopwareShippingMethodPrice } from "../../../ShoppingCart/store";

const PriceItemContainer = styled.div`
    padding: 0.5em;
    margin-top: 0.5em;
`;

const PriceItem = styled.div`
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dotted ${({ theme }) => theme.colors.blue.toString()};
`;

const sortList = (priceList: iShopwareShippingMethodPrice[] | undefined) => {
    if (!priceList) {
        return [];
    }
    return priceList.sort((a, b) => {
        return a.quantityStart - b.quantityStart;
    });
};

interface iShippingPriceList {
    priceList?: iShopwareShippingMethodPrice[];
}

const ShippingPriceList = ({ priceList }: iShippingPriceList) => {
    const sortedList = useMemo(() => sortList(priceList), [priceList]);
    if (!priceList || priceList.length < 1) {
        return null;
    }
    return (
        <PriceItemContainer>
            {sortedList.map((item) => (
                <div key={item.id}>
                    {item.quantityEnd && (
                        <PriceItem>
                            <>
                                <span>Bis {item.quantityEnd} KG</span>
                                <span>
                                    {item.currencyPrice &&
                                        item.currencyPrice[0].gross?.toFixed(
                                            2
                                        )}{" "}
                                    €
                                </span>
                            </>
                        </PriceItem>
                    )}
                </div>
            ))}
        </PriceItemContainer>
    );
};

export default ShippingPriceList;
